import { combineReducers } from "redux";
import accountSettingViewModel from "./accountSettingViewModel";

const rootViewModel = combineReducers({
    accountSettingViewModel
});

export default rootViewModel;
